import { FeatureFlags } from '../FeatureFlags';
import { Module } from '../Module';
import { UserSettings } from '../resources/UserSettings';
import { IResult } from '../ServerApi/types/IResponse';
import { PasswordPolicyScope, PasswordPolicyService } from '../services/PasswordPolicyService';
import { ServerService } from '../services/ServerService';
import { ChangePasswordNotification } from '../services/UserSettingsNotification';

export interface IChangePasswordScope extends PasswordPolicyScope {
  busy: boolean;
  clearAndCollapseFields: () => void;
  clearAndShowFields: () => void;
  disableSaveButton: () => boolean;
  passwordChanged: () => boolean;
  editMode: boolean;
  fields: {
    currentPassword: string;
    confirmPassword: string;
    newPassword: string;
  };
  passwordForm: ng.IFormController;
  requireCurrentPassword: boolean;
  save: () => ng.IPromise<any>;
  userId(): string;
  username(): string;
  domainName(): string;
}

Module.instance().directive('tbChangePassword', [
  'ChangePasswordNotification',
  'ServerService',
  'PasswordPolicyService',
  'UserSettings',
  (changePasswordNotification: ChangePasswordNotification,
   serverService: ServerService,
   passwordPolicyService: PasswordPolicyService,
   userSettings: UserSettings) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'changePassword.html',
      scope: {
        userId: '&',
        username: '&',
        domainName: '&',
      },
      link: (scope: IChangePasswordScope) => {

        scope.busy = false;

        scope.fields = {
          currentPassword: '',
          confirmPassword: '',
          newPassword: ''
        };

        scope.editMode = false;

        // Require confirming your current password to change your own password
        scope.requireCurrentPassword = serverService.isSessionUserSelf(scope.username(), scope.domainName());

        scope.clearAndCollapseFields = () => {
          scope.fields.currentPassword = '';
          scope.fields.newPassword = '';
          scope.fields.confirmPassword = '';
          scope.editMode = false;
        };

        scope.clearAndShowFields = () => {
          scope.fields.currentPassword = '';
          scope.fields.newPassword = '';
          scope.fields.confirmPassword = '';
          scope.editMode = true;
        };

        scope.passwordChanged = () => {
          return scope.fields.currentPassword !== scope.fields.newPassword;
        };

        scope.save = () => {
          scope.busy = true;
          const currentPassword = scope.fields.currentPassword;
          const newPassword = scope.fields.newPassword;
          const userId = scope.userId();
          return userSettings.changeUserPassword(userId, newPassword, currentPassword)
            .then((result: IResult) => {
              // toasts
              changePasswordNotification.notify(result, scope.username());
              scope.busy = false;
              scope.clearAndCollapseFields();
            });
        };

        const respectsPasswordValidation =
          passwordPolicyService.loadPoliciesIntoScope(scope, () => scope.fields.newPassword, () => {});

        scope.disableSaveButton = () => {
          return scope.passwordForm.$invalid || scope.busy || !respectsPasswordValidation() ||
            (FeatureFlags.localAuthPasswordExpirationEnabled && !scope.passwordChanged());
        };
      }
    };
  }
]);
